import React from 'react';
import {
  makeStyles,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@material-ui/core';

import { Home, AcUnit, Pets, MoreHoriz, Warning } from '@material-ui/icons';

const useStyle = makeStyles((theme) => ({
  appbar: {
    position: 'fixed',
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    left: theme.spacing(0),
    color: "transparent",
    elevation: 5,
  },
  tabButton: {
    minWidth: 40,
  }
}));

const Bottombar = (props) => {
  const classes = useStyle();

  const { tabBarIndex, setTabBarIndex, setLoading } = props;

  const handleChange = (event, newValue) => {
    setTabBarIndex(newValue);
    setLoading(true);
  };

  return (
    <>
        <Paper className={classes.appbar}>
          <BottomNavigation
            showLabels
            value={tabBarIndex}
            onChange={handleChange}
          >
            <BottomNavigationAction label="Recent" icon={<Home />} className={classes.tabButton} />
            <BottomNavigationAction label="Severe" icon={<Warning />} className={classes.tabButton}/>
            <BottomNavigationAction label="Microbe" icon={<AcUnit />} className={classes.tabButton}/>
            <BottomNavigationAction label="Pet" icon={<Pets />} className={classes.tabButton}/>
            <BottomNavigationAction label="Other" icon={<MoreHoriz />} className={classes.tabButton}/>
          </BottomNavigation>
        </Paper>
    </>
  );
};

export default Bottombar;
